var React = require('react');

function CopyIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"stroke","d":"M13.1719 18.8287L18.8287 13.1719M11.0506 15.293L9.63642 16.7072C8.07432 18.2693 8.07432 20.8019 9.63642 22.364C11.1985 23.9261 13.7312 23.9261 15.2933 22.364L16.7075 20.9498M15.293 11.0501L16.7072 9.63593C18.2693 8.07383 20.8019 8.07383 22.364 9.63593C23.9261 11.198 23.9261 13.7307 22.364 15.2928L20.9498 16.707","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CopyIcon.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = CopyIcon;

CopyIcon.default = CopyIcon;
